import { useMutation } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrorsAndJSON } from 'utils/handle-errors'

interface ValidateParams {
  dealId: string
}

export interface SandboxInfo {
  id: number
  email: string
  phone_number: string
  status: string
  organization_id: number
  partner_integration_id: number
}

export interface ValidateDealResponse {
  status: string
  message: string
  deal_id: string
  deal_name?: string
  contact: {
    email: string
    firstname: string
    lastname: string
    name: string
  }
  company: {
    name: string
  }
  sandbox?: SandboxInfo | null
  sandbox_suggestions?: SandboxInfo[]
  cli?: {
    cli: true
    partner_integration_id: number
    organization_id: number
  } | null
}

const sendHubspotDealValidation = async ({
  dealId,
}: ValidateParams): Promise<ValidateDealResponse> => {
  const url = `${BASE_API_URL}/api/v1/hubspot/validate_deal`

  const response = await fetch(url, {
    method: API_METHODS.POST,
    headers: apiHeaders(store.getState()), // Use apiHeaders for auth
    body: JSON.stringify({ extractedId: dealId }),
  })

  const handledResponse = await handleErrorsAndJSON(response)
  const jsonResponse = await handledResponse.json()
  return jsonResponse
}

const useValidateHubspotDeal = () => {
  return useMutation<ValidateDealResponse, Error, ValidateParams>(
    sendHubspotDealValidation
  )
}

export default useValidateHubspotDeal
